module.exports = __webpack_public_path__ + "assets/img/21.f4a3f7ea.png";